import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../config';

const useClient = () => {
  const token = Cookies.get('_barbToken');

  const client = axios.create({
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    baseURL: config.everywhereApi
  });

  client.interceptors.request.use(async (config) => {
    return {
      ...config,
      headers: {
        ...config.headers,
        ...(token && { Authorization: `Bearer ${token}` })
      }
    };
  });

  return client;
};

export default useClient;
